import {Box, Button, Container, Grid} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import {Link} from "react-router-dom";
import {NOME_APP} from "../../shared/env";
import HeaderMenu from "./HeaderMenu";

import ModoAplicacao from "./ModoAplicacao";
import {nomeAplicacaoNeutro} from "../../shared/modoAplicacao";
import IdentificacaoSessao from "./IdentificacaoSessao";

export const ALTURA_CABECALHO = {xs: 188, sm: 124};

function Header({maxWidth = "lg"}) {
    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}
            >
                <Toolbar sx={{minHeight: {xs: 116, sm: 84}}}>
                    <Container maxWidth={maxWidth}>
                        <Grid
                            container
                            sx={{
                                flexWrap: {xs: "wrap", sm: "nowrap"},
                                columnGap: 2,
                                rowGap: 1
                            }}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item sx={{minWidth: 0, flex: 1}}>
                                <Button
                                    component={Link}
                                    to="/"
                                    sx={{
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "1.25rem",
                                        fontWeight: 500,
                                        height: 40,
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            width: 34,
                                            height: 34,
                                            mr: 1.25,
                                            p: 0.25,
                                            flexShrink: 0,
                                            display: "grid",
                                            placeItems: "center",
                                            bgcolor: "common.white",
                                            borderRadius: 1.5
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={`${process.env.PUBLIC_URL}/favicon-esfinge.png`}
                                            alt="Símbolo do e-Sfinge"
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="span"
                                        sx={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                    >
                                        {nomeAplicacaoNeutro(NOME_APP)}
                                    </Box>
                                </Button>
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    order: {xs: 3, sm: 2},
                                    width: {xs: "100%", sm: "auto"},
                                    maxWidth: {sm: "45%"}
                                }}
                            >
                                <IdentificacaoSessao showEnvironment={false} />
                            </Grid>
                            <Grid
                                item
                                sx={{flexShrink: 0, order: {xs: 2, sm: 3}}}
                            >
                                <HeaderMenu />
                            </Grid>
                        </Grid>
                    </Container>
                </Toolbar>
                <Box
                    sx={{
                        bgcolor: "background.paper",
                        color: "text.primary",
                        height: {xs: 72, sm: 40},
                        borderBottom: 1,
                        borderColor: "divider"
                    }}
                >
                    <Container maxWidth={maxWidth}>
                        <ModoAplicacao />
                    </Container>
                </Box>
            </AppBar>
        </>
    );
}

export default Header;
